// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelCategory-Components-Search-css-module__container--vHsW4"};